import VideoSection from "../components/landing_components/VideoSection";
import AppDownload from "../components/landing_components/CTA";
import BottomNavbar from "../components/landing_components/bottomNavbar";

// #ABC1DE
export default function LandingPage() {
  return (
    <div className="w-full bg-white">
      {/* Navbar - Only visible on mobile */}
      <div className="lg:hidden">
        <BottomNavbar />
      </div>

      {/* Mobile Layout (Stack) */}
      <div className="block lg:hidden w-full">
        {/* Video Section - Adjusted for 1:1 aspect ratio */}
        <div className="w-full aspect-square relative">
          <VideoSection />
        </div>

        {/* CTA Section */}
        <div className="w-full pb-20">
          <AppDownload />
        </div>
      </div>

      {/* Desktop Layout (Side by Side) */}
      <div className="hidden lg:flex min-h-screen w-full overflow-hidden">
        {/* Logo */}
        <div className="absolute top-0 left-0 p-4 md:p-6 hidden md:block z-10">
          <img
            src="/images/ping-desi-logo.png"
            alt="Company Logo"
            className="h-8 md:h-10 xl:h-10 2xl:h-16 w-auto"
          />
        </div>

        {/* CTA Section - Left half */}
        <div className="w-1/2 h-screen overflow-y-auto flex items-center justify-center p-4">
          <AppDownload />
        </div>

        {/* Video Section - Right half */}
        <div className="w-1/2 h-screen flex items-center justify-end overflow-hidden">
          <div className="h-full w-full flex items-center justify-center">
            <VideoSection />
          </div>
        </div>
      </div>
    </div>
  );
}
